import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";

const doorToECGDayWise = [
  { label: "Mon", avgTime: 6.8 },
  { label: "Tue", avgTime: 7.1 },
  { label: "Wed", avgTime: 6.5 },
  { label: "Thu", avgTime: 7.4 },
  { label: "Fri", avgTime: 7.0 },
  { label: "Sat", avgTime: 7.9 },
  { label: "Sun", avgTime: 7.6 },
];

/* Tooltip */
const ECGTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="bg-white p-3 rounded-lg shadow-md border text-sm min-w-[170px]">
      <p className="font-semibold mb-1">{label}</p>
      <div className="flex justify-between font-semibold text-rose-900">
        <span>Avg ECG Time :</span>
        <span>{payload[0].value} min</span>
      </div>
    </div>
  );
};

export default function DoorToECGAreaChart() {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={doorToECGDayWise}
        margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
      >
        {/* Crimson Gradient */}
        <defs>
          <linearGradient id="ecgGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#9F1239" stopOpacity={0.45} />
            <stop offset="100%" stopColor="#9F1239" stopOpacity={0} />
          </linearGradient>
        </defs>

        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#e5e7eb"
        />

        <XAxis
          dataKey="label"
          tick={{ fontSize: 12 }}
          stroke="#6b7280"
          interval={0}
        />
        <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => `${v}m`} />

        <Tooltip content={<ECGTooltip />} />

        <Area
          type="monotone"
          dataKey="avgTime"
          stroke="#9F1239"
          fill="url(#ecgGradient)"
          strokeWidth={3}
          dot={{
            r: 3,
            fill: "#9F1239",
            stroke: "#9F1239",
            strokeWidth: 3,
          }}
          activeDot={{ r: 3 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
